<template>
  <Row class-name="modifyRegister" :style="minHeight">
    <Spin v-if="loading" fix></Spin>
    <Col>
      <BreadcrumbWrap />
      <p class="title">修改查档信息登记</p>
    </Col>
    <Col span="24">
      <Row type="flex" justify="center">
        <Col :xxl="14" :xl="18" :sm="22" :xs="24">
          <InfoRegister
            v-if="formItems.length"
            :formItems="formItems"
            :otherParams="otherParams"
            :unitType="item.SubscribeType"
          >
            <Button
              type="primary"
              @click="handGoBack('modify-search')"
            >返回查档申请</Button>
            <Button
              type="primary"
              @click="handGoBack('record')"
            >返回查档记录</Button>
          </InfoRegister>
        </Col>
      </Row>
    </Col>
  </Row>
</template>

<script>
import InfoRegister from '@components/info-register'
import { editForm } from '../reservation/formItems'
import BreadcrumbWrap from '@components/breadcrumb-wrap'
import { FindArchSub, GetEngineersByCondi } from '@api'
export default {
  name: 'modifyRegister',
  components: { InfoRegister, BreadcrumbWrap },
  data () {
    return {
      formItems: [],
      item: {},
      engItems: [],
      loading: false
    }
  },
  computed: {
    minHeight () {
      return { 'min-height': `${this.$store.state.init.offsetHeight - 251}px` }
    },
    otherParams () {
      const { CDType, SID } = this.item
      return { CDType, SID }
    }
  },
  async mounted () {
    await this.buildItem()
    await this.buildFormItems()
  },
  activated () {
    this.setFormValue()
  },
  methods: {
    async buildItem () {
      this.loading = true
      try {
        const sid = this.$route.query.sid || 205
        this.item = (await FindArchSub({ sid })).data || {}
        this.engItems = (await GetEngineersByCondi({ ArchiveIDS: this.item.ArchiveIDS })).data || []
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    async buildFormItems () {
      this.loading = true
      try {
        const formItems = await editForm.call(this)
        this.$set(this, 'formItems', formItems)
      } catch (e) {
        console.error(e)
      }
      this.loading = false
    },
    handGoBack (name) {
      const route = this.$route
      this.$router.push({
        name,
        query: route.meta.query ? route.query : '',
        params: { reload: true }
      })
    },
    setFormValue () {
      const items = this.$route.params.item || []
      const engItem = []
      items.map(m => !engItem.some(s => s.ENG_SID === m.ENG_SID ) && engItem.push(m))
      this.formItems.map(m => {
        const { key } = m
        if (key === 'ArchiveIDS') {
          this.$set(m, 'value', engItem.map(m => m.ENG_SID).join(','))
          this.$set(m, 'options', engItem.map(m => ({
            value: m.ENG_SID,
            text: m.ENG_NAME
          })))
        } else if (key === 'QueryContent') {
          this.$set(m, 'value', items)
          this.$set(m, 'options', items.map(m => ({
            value: m.SID,
            text: m.FILE_TITLE
          })))
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
.modifyRegister {
  background: #fff;
  padding: 16px;
  border-top: 2px solid $default;
}
.title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  margin-top: 16px;
  margin-bottom: 4px;
}
</style>